import React, { useState, useEffect } from "react";
import { useBottomNav } from '../../context/BottomNavContext';

export default function Tabs({ tabs, defaultActiveTab = "all", children }) {
  const [activeTab, setActiveTab] = useState(defaultActiveTab);
  const { height, isSmallScreen } = useBottomNav();
  const [contentHeight, setContentHeight] = useState('auto');

  // Dynamically calculate available height based on screen size and other factors
  useEffect(() => {
    const calculateHeight = () => {
      const screenHeight = window.innerHeight;
      const navHeight = height || 80;
      const headerHeight = isSmallScreen ? 230 : 260; // Estimate for other UI elements
      
      // Calculate available space
      const availableHeight = screenHeight - navHeight - headerHeight;
      setContentHeight(`${Math.max(300, availableHeight)}px`);
    };
    
    calculateHeight();
    window.addEventListener('resize', calculateHeight);
    
    return () => {
      window.removeEventListener('resize', calculateHeight);
    };
  }, [height, isSmallScreen]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div>
      {/* Tabs Navigation */}
      <div className="overflow-x-auto whitespace-nowrap hide-scrollbar">
        <div className="flex gap-1.5 border-gray-200 mt-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`text-sm max-xs:text-xs font-semibold text-white px-2.5 py-0.5 rounded-md ${
                activeTab === tab.id
                  ? "bg-[#0E64D1]"
                  : "bg-[#0E64D166]"
              }`}
            >
              {tab.title.toUpperCase()}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div 
        className="mt-4 overflow-y-auto hide-scrollbar" 
      >
        {children.map((child) =>
          React.cloneElement(child, { isActive: child.props.id === activeTab })
        )}
      </div>
    </div>
  );
}

export function TabItem({ id, isActive, children }) {
  if (!isActive) return null;
  return <div>{children}</div>;
}
